// 培训级别
const pxLevel = [
  { value: '0.0', label: '0.0' },
  { value: '1.0', label: '1.0' },
  { value: '1.5', label: '1.5' },
  { value: '2.0', label: '2.0' },
  { value: '2.5', label: '2.5' },
  { value: '3.0', label: '3.0' },
  { value: '3.5', label: '3.5' },
  { value: '4.0', label: '4.0' },
  { value: '4.5', label: '4.5' },
  { value: '5.0', label: '5.0' }
]
//培训状态
const pxState = [
  { label: '未审核', value: 1 },
  { label: '已拒绝', value: 2 },
  { label: '已发布', value: 3 },
  { label: '报名中', value: 4 },
  { label: '报名结束', value: 5 },
  { label: '已开训', value: 6 },
  { label: '已结束', value: 7 },
  { label: '已取消', value: 8 }

]
const pxState2 = {
  1: '未审核',
  2: '已拒绝',
  3: '已发布',
  4: '报名中',
  5: '报名结束',
  6: '已开训',
  7: '已结束',
  8: '已取消'
}
const pxStateMap = {
  1: { label: '未审核', type: 'danger' },
  2: { label: '已拒绝', type: 'warning' },
  3: { label: '已发布', type: 'success' },
  4: { label: '报名中', type: 'warning' },
  5: { label: '报名结束', type: 'warning' },
  6: { label: '已开训', type: 'warning' },
  7: { label: '已结束', type: 'warning' },
  8: { label: '已取消', type: 'warning' }
}

const pxType = { '1': '单次培训', '2': '整期培训', '3': '青少年儿童培训', '4': '个人定制化培训', '5': '团体定制化培训', '6': '分级升级培训' }
//培训类型
const pxType2 = [
  { label: '单次培训', value: 1 },
  { label: '整期培训', value: 2 },
  { label: '青少年儿童培训', value: 3 },
  { label: '个人定制化培训', value: 4 },
  { label: '团体定制化培训', value: 5 },
  { label: '分级升级培训', value: 6 }
]
//团体培训类型
const groupPxType = { 1: '成人培训', 2: '青少年儿童培训', 3: '团体/组织培训', 4: '其他' }
const groupPxType2 = [
  { label: '成人培训', value: 1 },
  { label: '青少年儿童培训', value: 2 },
  { label: '团体/组织培训', value: 3 },
  { label: '其他', value: 4 }
]
//角色限定
const roleType = {
  1: '在职人员',
  2: '在校人员',
  3: '退休人员',
  4: '志愿者',
  5: '家长',
  6: '其他'
}
//会员类型
const personType = {
  1: '注册会员',
  2: '初始会员',
  3: '荣誉会员'
}
//关系
const relationOptions = {
  1: '家长',
  2: '老师',
  3: '朋友',
  4: '其他'
}
// 支付方式
const payType = {
  1: '微信',
  2: '代金券',
  3: '微信+代金券'
}
export default {
  pxLevel,
  pxState,
  pxState2,
  pxStateMap,
  pxType,
  pxType2,
  roleType,
  groupPxType,
  groupPxType2,
  personType,
  relationOptions,
  payType

}